import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { languageService } from "api/services/language.service";
import { useLanguage } from "stores/useLanguage";

export const useAvailableLanguages = () => {
  const languages = useLanguage((s) => s.languages);
  const setLanguages = useLanguage((s) => s.setLanguages);

  // تنها زمانی که لیست زبان‌ها در Zustand خالی است نیاز به فچ کردن داریم
  const shouldFetch = languages.length === 0;

  const query = useQuery({
    queryKey: ["languages"],
    queryFn: languageService.getAll,
    staleTime: Infinity,
    gcTime: Infinity,
    enabled: shouldFetch, 
  });

  useEffect(() => {
    if (query.data && query.data.length > 0 && languages.length === 0) {
      setLanguages(query.data);
    }
  }, [query.data, languages.length, setLanguages]);

  return {
    languages: languages.length > 0 ? languages : (query.data ?? []),
    // منطق لودینگ اصلاح شد: فقط وقتی واقعا در حال دریافت از بک‌اند است لودینگ نشان بده
    isLoading: shouldFetch && query.isLoading,
    isError: query.isError,
  };
};
